import { render, staticRenderFns } from "./SCodeEditor.vue?vue&type=template&id=03b3f1a9&"
import script from "./SCodeEditor.vue?vue&type=script&lang=js&"
export * from "./SCodeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports